import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useStudent } from "../context/StudentContext";
import { resolveStudentTabDestination } from "../utils/studentTabRouting";

/**
 * Resolves legacy or slug-based course tab URLs to registered student routes.
 */
function StudentTabRedirect() {
  const { tabSlug } = useParams();
  const location = useLocation();
  const { activeCourseTabHints } = useStudent();
  const segment = typeof tabSlug === "string" ? tabSlug.trim() : "";
  const params = new URLSearchParams(location.search);
  const pestanaFromQuery = (params.get("pestana") || "").trim();
  const labelForResolve = pestanaFromQuery.length > 0 ? pestanaFromQuery : segment;
  const { routeSlug, pestana } = resolveStudentTabDestination(labelForResolve, activeCourseTabHints);
  const nextParams = new URLSearchParams();
  if (pestana.length > 0) {
    nextParams.set("pestana", pestana);
  }
  ["bloque", "tema"].forEach((key) => {
    const value = (params.get(key) || "").trim();
    if (value.length > 0) {
      nextParams.set(key, value);
    }
  });
  const search = nextParams.toString() ? `?${nextParams.toString()}` : "";

  return (
    <Navigate
      to={{ pathname: `/usuario/${routeSlug}`, search }}
      replace
    />
  );
}

export default StudentTabRedirect;
